import { useState } from 'react';
import { Grid, Typography, Button, Paper, ListItemButton } from '@mui/material';
import { AddRounded } from '@mui/icons-material';
import RowDialog from './RowDialog';
import MiniField from './MiniField';
import { isArray } from 'lodash';
import { v4 } from 'uuid';

export default function FormStyleFieldTable({
  columns,
  rows,
  onChange,
  editable,
  tableConfig,
  allCreatedActions,
  onCreatedAction,
  onDeletedAction,
  activityInfo,
  summaryComponent,
}) {
  const [currRowId, setCurrRowId] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);

  const addRowButtonText = tableConfig?.settings?.addRowButtonText ?? 'add another row';
  // if row bar columns not set - take the first 3 columns
  const rowBarColumns = isArray(columns)
    ? isArray(tableConfig?.settings?.rowBarColumns)
      ? columns.filter((x) => tableConfig.settings.rowBarColumns.includes(x.id))
      : columns.filter((_x, i) => i < 3)
    : [];

  function defaultRow() {
    return {
      id: v4(),
      index: rows.length + 1,
      ...columns.reduce((prev, curr) => ({ ...prev, [curr.id]: { value: null } }), {}),
    };
  }

  function addRow() {
    const row = defaultRow();
    onChange([...rows, row]);
    setCurrRowId(row.id);
    setDialogOpen(true);
  }

  return (
    <Grid container>
      {rows.map((row, index) => (
        <Grid container key={row.id} component={Paper} variant="outlined" sx={{ my: 1 }}>
          <Grid
            container
            alignItems={'center'}
            component={ListItemButton}
            sx={{ p: 1.5, borderRadius: 1 }}
            onClick={() => {
              setCurrRowId(row.id);
              setDialogOpen(true);
            }}
          >
            <Grid container alignItems={'center'} spacing={1}>
              <Grid item>
                <Typography variant="h6" sx={{ mr: 1 }}>
                  #{index + 1}
                </Typography>
              </Grid>

              <Grid item>
                <Typography sx={{ fontStyle: 'italic' }}>Click to open</Typography>
              </Grid>

              <Grid sx={{ ml: 'auto' }} />

              {rowBarColumns.map((column, i) => (
                <Grid item key={i}>
                  <MiniField field={column} initial={row[column.id]} forBar />
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      ))}

      {(summaryComponent || editable) && (
        <Grid container alignItems={'center'} sx={{ mt: 1 }}>
          {summaryComponent}
          {editable && (
            <Button sx={{ ml: 'auto' }} onClick={addRow} variant="contained" startIcon={<AddRounded />}>
              {addRowButtonText}
            </Button>
          )}
        </Grid>
      )}

      <RowDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        initialRows={rows}
        currRowId={currRowId}
        onChange={onChange}
        columns={columns}
        editable={editable}
        activityInfo={activityInfo}
        tableConfig={tableConfig}
        allCreatedActions={allCreatedActions}
        onCreatedAction={onCreatedAction}
        onDeletedAction={onDeletedAction}
        addRowButtonText={addRowButtonText}
        onRowSelect={(id) => setCurrRowId(id)}
      />
    </Grid>
  );
}
